module.exports = __webpack_public_path__ + "img/productsBg.e9afb3ed.svg";